<template>
  <div class="">
    <Card class="p-m-2">
      <template #title> Roller</template>
      <template #content>
        <div class="mt-1 mb-2 mr-3">
          <Button icon="pi pi-plus " size="small" label="Yeni" @click="_RolModal()" />
        </div>
        <DataTable v-if="DataTable_render" :columns="columns" :data="RolListesi" v-on:set-child-data="getDataChild"
          :editbutton="true" />
      </template>
    </Card>

    <Dialog v-model:visible="RolModal" header="Rol" :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
      :style="{ width: '30vw' }" modal>

      <div class="formgrid grid ">
        <div class="field col md:col-6">
          <label for="spanRolAd" class="font-bold block">Rol Adı</label>
          <InputText id="spanRolAd" type="text" v-model="v$.RolAd.$model"
            :class="{ 'invalid': v$.RolAd.$invalid && submitted }" class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-6">
          <label for="spanRolTanim" class="font-bold block">Rol Tanım</label>
          <InputText id="spanRolTanim" type="text" v-model="v$.RolAciklama.$model"
            :class="{ 'invalid': v$.RolAciklama.$invalid && submitted }" class="text-base text-color w-full" />
        </div>
      </div>

      <Divider />
      <div class="flex justify-content-end flex-wrap">
        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
          @click="this.handleClick(!v$.$invalid)" autofocus />
        <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger"
          @click="this._RolModal()" />
      </div>

    </Dialog>
  </div>
</template>

<script>
import DataTable from "../../DataTable/BasicDataTable.vue";
import GlobalServis from "../../../../../services/GlobalServis";
import { required, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      DataTable_render: true,
      RolListesi: [],
      columns: [
        { field: "RolAd", header: "Rol Adı" },
        { field: "RolAciklama", header: "Rol Tanım" },
      ],
      RolModal: false,
      RolModelDurum: null,

      RolAd: null,
      RolAciklama: null,
      Rol_rowid: null,
    };
  },
  methods: {
    getDataChild(getdata_child) {
      this.RolModal = !this.RolModal;
      this.RolModelDurum = false;
      this.Rol_rowid = getdata_child.data.Rol_rowid;
      let data = {
        Rol_rowid: getdata_child.data.Rol_rowid,
      };
      GlobalServis.GlobalServis("POST", "GetRolInfo", data).then((res) => {
        if (res.status == 200) {
          this.v$.RolAd.$model = res.data[0].RolAd;
          this.v$.RolAciklama.$model = res.data[0].Aciklama;
          this.RolKod = res.data[0].Rol_rowid;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _RolModal() {
      this.RolModelDurum = true;
      this.RolModal = !this.RolModal;
      if (!this.RolModal) {
        // this.resetForm();
      }
    },
    handleClick(isFormValid) {
      this.submitted = true;
      if (isFormValid) {
        let data = {
          Rol_rowid: this.Rol_rowid,
          RolAd: this.RolAd,
          RolAciklama: this.RolAciklama,
        };
        if (this.RolModelDurum) {
          // Yeni Rol
          GlobalServis.GlobalServis("POST", "SetRol", data).then((res) => {
            if (res.status == 200) {
              this.$toast.add({
                severity: "success",
                summary: "Başarılı",
                detail: "Rol oluşturulmuştur",
                life: 3000,
              });
              this.Refresh();
              this._RolModal();
            } else if (res.response.status === 999) {
              this.$toast.add({
                severity: "warn",
                summary: "Uyarı",
                detail: res.response.data,
                life: 3000,
              });
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Hata",
                detail: "Hata oldu",
                life: 3000,
              });
            }
          }).then(() => {
          });

        } else {
          // Edit Rol
          GlobalServis.GlobalServis("POST", "UpdateRol", data).then((res) => {
            if (res.status == 200) {
              this.$toast.add({
                severity: "success",
                summary: "Başarılı",
                detail: "Rol düzenlemiştir",
                life: 3000,
              });
              this.Refresh();
              this._RolModal();
            } else if (res.response.status === 999) {
              this.$toast.add({
                severity: "warn",
                summary: "Uyarı",
                detail: res.response.data,
                life: 3000,
              });
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Hata",
                detail: "Hata oldu",
                life: 3000,
              });
            }
          }).then(() => {
          });
        }
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Gerekli Alan Uyarısı",
          detail: "Lütfen tüm alanları doldurunuz",
          life: 3000,
        });
      }
    },
    Refresh() {
      this.DataTable_render = false;
      this.$nextTick(() => {
        this.InitServis();
        this.DataTable_render = true;
      });
    },
    InitServis() {
      GlobalServis.GlobalServis("GET", "GetRolTablosu", "").then((res) => {
        if (res.status == 200) {
          this.RolListesi = res.data;
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
      });

    },
  },
  mounted() {
    this.InitServis();
  },
  components: {
    DataTable,
  },
  validations() {
    return {
      RolAd: {
        required: helpers.withMessage("Bu alan boş bırakılamaz", required),
      },
      RolAciklama: {
        required: helpers.withMessage("Bu alan boş bırakılamaz", required),
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>../../../../services/GlobalServis
